/*eslint-disable */
import i18n from '../locales';
import Multiselect from 'vue-multiselect';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from 'moment';

import routesEscl from '../locales/es-CL/routes.json';
import routesEsmx from '../locales/es-MX/routes.json';
import routesEsco from '../locales/es-CO/routes.json';
import routesEnus from '../locales/en-US/routes.json';

export default {
  name: 'RoutesForm',
  props: ['item', 'callback'],
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      launched: false,
      form: {},
    };
  },
  computed: {
    options() {
      return {
        status: [
          {
            value: 'notOperator',
            text: this.t('routes.formulario.campos.statusOptions.notOperator'),
          },
          {
            value: 'notAssigned',
            text: this.t('routes.formulario.campos.statusOptions.notAssigned'),
          },
          {
            value: 'partiallyAssigned',
            text: this.t('routes.formulario.campos.statusOptions.partiallyAssigned'),
          },
          {
            value: 'assigned',
            text: this.t('routes.formulario.campos.statusOptions.assigned'),
          },
          {
            value: 'toBeUnassigned',
            text: this.t('routes.formulario.campos.statusOptions.toBeUnassigned'),
          },
          {
            value: 'unassigned',
            text: this.t('routes.formulario.campos.statusOptions.unassigned'),
          },
          {
            value: 'onGoing',
            text: this.t('routes.formulario.campos.statusOptions.onGoing'),
          },
          {
            value: 'ended',
            text: this.t('routes.formulario.campos.statusOptions.ended'),
          },
          {
            value: 'endedIncomplete',
            text: this.t('routes.formulario.campos.statusOptions.endedIncomplete'),
          },
          {
            value: 'notEnded',
            text: this.t('routes.formulario.campos.statusOptions.notEnded'),
          },
          {
            value: 'cancelled',
            text: this.t('routes.formulario.campos.statusOptions.cancelled'),
          },
          {
            value: 'assigned',
            text: this.t('routes.formulario.campos.statusOptions.assigned'),
          },
          {
            value: 'notAssigned',
            text: this.t('routes.formulario.campos.statusOptions.notAssigned'),
          },
          {
            value: 'inProgress',
            text: this.t('routes.formulario.campos.statusOptions.inProgress'),
          },
          {
            value: 'finished',
            text: this.t('routes.formulario.campos.statusOptions.finished'),
          },
          {
            value: 'assigned',
            text: this.t('routes.formulario.campos.statusOptions.assigned'),
          },
          {
            value: 'notAssigned',
            text: this.t('routes.formulario.campos.statusOptions.notAssigned'),
          },
        ],
      };
    },

    titulo() {
      return this.t('routes.formulario.titulos.viewFormTitle', { routeId: this.form.id });
    },
  },
  methods: {
    formatNominalTime(segundos) {
      let secs = Math.round(segundos);
      let hours = Math.floor(secs / (60 * 60));
      let divisor_for_minutes = secs % (60 * 60);
      let minutes = Math.floor(divisor_for_minutes / 60);

      let divisor_for_seconds = divisor_for_minutes % 60;
      let seconds = Math.ceil(divisor_for_seconds);
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0',
      )}`;
    },
    setForm() {
      const currentStatus = this.options.status.find((v) => v.value.toUpperCase() === this.item.state.toUpperCase());
      return {
        id: this.item.id,
        name: this.item.name,
        status: currentStatus ? currentStatus.text : '',
        //trips: this.item.trips,
        start: moment(Date.parse(this.item.startDate)).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(Date.parse(this.item.endDate)).format('YYYY-MM-DD HH:mm:ss'),
        origin: this.item.origin,
        destination: this.item.destination,
        totalTime: this.formatNominalTime((Date.parse(this.item.endDate) - Date.parse(this.item.startDate)) / 1000),
        loadTime: this.formatNominalTime(this.item.loadTime),
        kms: Math.ceil(this.item.totalDrivingDistance/1000),
      };
    },

    t(key) {
      return i18n.t(key);
    },
    t(key, data) {
      return i18n.t(key, data);
    },
    closeModal() {
      this.$bvModal.hide('routes-form-modal');
    },
  },
  async mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 500);
    });

    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      routes: routesEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      routes: routesEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      routes: routesEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      routes: routesEnus,
    });
    this.form = this.setForm();
  },
};
